import React, { useState, useContext } from "react";

import { Auth } from "aws-amplify";

import { ThemeContext, ThemeConstants } from "../App";

const Navbar = ({ auth, baseFont }) => {
  const currentTheme = process.env.REACT_APP_THEME;
  const themeConfig = useContext(ThemeContext);
  const themeConstants = useContext(ThemeConstants);

  const [scrollPos, setScrollPos] = useState("");
  const [showMobileAndTabletMenu, setShowMobileAndTabletMenu] = useState(false);

  const navHeight = currentTheme === "homelink" ? "h-[100px]" : "h-70";
  const logoStyle =
    currentTheme === "homelink" ? "xl:ml-32 w-60" : "xl:ml-32 w-40 2xl:w-44";

  if (typeof window !== "undefined") {
    window.onscroll = () => {
      setScrollPos(window.scrollY);
    };
  }

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await Auth.signOut();
      props.auth.setAuthStatus(false);
      props.auth.setCurrentUser(null);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 z-40 w-full navbar base-font shadow-md ${themeConfig.navbarBgColor} ${navHeight}`}
        style={baseFont}
      >
        <div
          className={` ${navHeight} ${themeConfig.navbarBgColor} ${themeConfig.navbarTextColor} fixed max-w-screen-2xl left-0 right-0 px-4 lg:px-0 mx-auto flex items-center justify-around xl:justify-between`}
        >
          <a
            href={
              themeConstants.MARKETING_URL ? themeConstants.MARKETING_URL : "/"
            }
          >
            <img
              src={themeConfig.logo}
              alt="brand logo"
              className={`${logoStyle}`}
            />
          </a>
          {themeConstants.SHOP_URL && (
            <div className="hidden sm:flex">
              <span className="mx-6">|</span>
              <a
                href={themeConstants.SHOP_URL}
                className="mr-auto text-base underline"
              >
                Continue Shopping
              </a>
            </div>
          )}
          <div
            className={`flex justify-end xl:justify-around items-center ml-auto ${
              process.env.REACT_APP_STORE_PHONE.length > 0 ? "" : "md:mr-48"
            }`}
          >
            <div className="icons flex">
              <ul className="flex-row items-center navmenu flex">
                <li className="relative cursor-pointer group">
                  {parseInt(themeConstants.MYACCOUNT_URL) !== 0 && (
                    <>
                      <button
                        onClick={() => setShowMobileAndTabletMenu(false)}
                        type="button"
                        className={`w-9 h-12 xl:p-2 text-2xl transition duration-500 ease-in-out rounded-full focus:outline-none ${themeConfig.navbarTextColor}`}
                        aria-label="User Account"
                      >
                        <i className="fa fa-user-circle" />
                      </button>
                      {auth && auth.isAuthenticated && auth.user ? (
                        <ul className="absolute right-3 top-7 hidden px-3 pt-2 pb-2 m-0 font-medium bg-white rounded-md shadow-md group-hover:block w-max z-50">
                          <li
                            className={`flex flex-col items-baseline text-sm px-3 py-2 text-[#243746] normal-case`}
                          >
                            Logged In as:
                            <p className="text-sm block border-b pb-3">
                              {
                                auth.user.signInUserSession.idToken.payload
                                  .email
                              }
                            </p>
                          </li>
                          <li
                            className={`flex flex-row items-baseline normal-case text-sm hover:underline px-3 py-2 cursor-pointer text-[#243746] ${themeConfig.navbarTextHoverColor}`}
                          >
                            <a
                              href={`${themeConstants.MARKETING_URL}/home-login`}
                            >
                              Control My Home
                            </a>
                          </li>
                          <li
                            className={`flex flex-row items-baseline normal-case text-sm hover:underline px-3 py-2 cursor-pointer text-[#243746] ${themeConfig.navbarTextHoverColor}`}
                          >
                            <a href={themeConstants.ACCOUNT_URL}>
                              Manage My Account
                            </a>
                          </li>
                          <li
                            className={`flex flex-row items-baseline normal-case text-sm hover:underline px-3 py-2 cursor-pointer text-[#243746] ${themeConfig.navbarTextHoverColor}`}
                          >
                            <a href="/" onClick={handleLogout}>
                              Sign Out
                            </a>
                          </li>
                        </ul>
                      ) : (
                        <ul className="absolute right-3 top-7 hidden px-3 pt-2 pb-2 m-0 font-medium bg-white rounded-md shadow-md group-hover:block w-max z-50">
                          <li
                            className={`flex flex-row items-baseline normal-case text-sm hover:underline px-3 py-2 cursor-pointer text-[#243746] ${themeConfig.navbarTextHoverColor}`}
                          >
                            <a
                              href={`${themeConstants.MARKETING_URL}/home-login`}
                            >
                              Control My Home
                            </a>
                          </li>
                          <li
                            className={`flex flex-row items-baseline normal-case text-sm hover:underline px-3 py-2 cursor-pointer text-[#243746] ${themeConfig.navbarTextHoverColor}`}
                          >
                            <a
                              href={`https://${themeConstants.COGNITO_DOMAIN}/login?&state=STATE&scope=email+openid+profile&response_type=code&client_id=${themeConstants.COGNITO_APP_CLIENT_ID}&redirect_uri=${themeConstants.COGNITO_REDIRECT_URI}`}
                            >
                              Manage My Account
                            </a>
                          </li>
                        </ul>
                      )}
                    </>
                  )}
                </li>
              </ul>
            </div>
          </div>
          {process.env.REACT_APP_STORE_PHONE.length > 0 ? (
            <div className="hidden md:flex">
              <span className="mx-4">|</span>
              <a
                href={`tel:${process.env.REACT_APP_STORE_PHONE}`}
                className={`2xl:pr-2 text-sm 2xl:text-base transition duration-300 easy-in-out font-bold lg:flex xl:mr-32 ${themeConfig.navbarTextColor} ${themeConfig.navbarTextHoverColor}`}
              >
                {process.env.REACT_APP_STORE_PHONE}
              </a>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {process.env.REACT_APP_STORE_PHONE.length > 0 ? (
        <div className="flex md:hidden mt-[120px]">
          <span className="mx-4">|</span>
          <a
            href={`tel:${process.env.REACT_APP_STORE_PHONE}`}
            className={`2xl:pr-2 text-sm 2xl:text-base transition duration-300 easy-in-out font-bold lg:flex xl:mr-32 ${themeConfig.navbarTextColor} ${themeConfig.navbarTextHoverColor}`}
          >
            {process.env.REACT_APP_STORE_PHONE}
          </a>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Navbar;
